export {
  AXIS_ORDER,
  PICK_EDGE_ON_THRESHOLD,
  PICK_RADIAL_TOLERANCE,
} from '../constants';
export { AXIS_COLOR_BY_KEY } from '../../constants';

export const ACTIVE_RING_OPACITY = 1;
export const IDLE_RING_OPACITY = 0.75;
export const RING_RADIUS = 0.56;
export const RING_SEGMENT_COUNT = 120;
export const RING_DASH_DEGREES = 3.2;
export const RING_GAP_DEGREES = 1.2;
export const RING_HALF_WIDTH = 0.01;
export const RING_HALF_WIDTH_SELECTED = 0.015;
export const RING_DELTA_SWEEP_HALF_WIDTH = 0.008;
export const RING_DELTA_SWEEP_RADIUS = RING_RADIUS - 0.08;
export const RING_DELTA_SWEEP_OPACITY = 1;
export const RING_DELTA_SWEEP_FILL_RADIUS = RING_DELTA_SWEEP_RADIUS;
export const RING_DELTA_SWEEP_FILL_OPACITY = 0.45;
export const RING_DELTA_SWEEP_MIN_DEGREES = 0.1;
export const AXIS_ARROW_ANGLE_DEGREES = 36;
export const AXIS_ARROW_HEIGHT = 0.09;
export const AXIS_ARROW_RADIUS = 0.024;
export const AXIS_ARROW_RADIAL_OFFSET = 0.00;
export const AXIS_ARROW_IDLE_OPACITY = 0.88;
export const AXIS_ARROW_ACTIVE_OPACITY = 1;
export const PREFERRED_ANGLE_EPSILON = 1e-4;

export const GHOST_LINE_OPACITY = 0.8;
export const GHOST_LINE_WIDTH = 2.1;
export const GHOST_DASH_FACTOR = 0.065;
export const GHOST_GAP_FACTOR = 0;
export const GHOST_DASH_MIN = 0.004;
export const GHOST_GAP_MIN = 0;
export const GHOST_RENDER_ORDER = 998.8;
